<article class="flex flex-col gap-12">
  <app-hero />
  <app-rates />
  <app-contact-us />
  <app-office />
  <app-testimonials />
  <app-how-it-work />
  <app-reasons-why-us />
  <app-did-not-enough />
  <app-about-us />
  <app-notice />
</article>
<back-to-top></back-to-top>
